__turbopack_context__.v({
  "Content": "post-list-module__Q8vjHW__Content",
  "Header": "post-list-module__Q8vjHW__Header",
  "HeaderLeft": "post-list-module__Q8vjHW__HeaderLeft",
  "HeaderRight": "post-list-module__Q8vjHW__HeaderRight",
  "PostList": "post-list-module__Q8vjHW__PostList",
  "PostListContent": "post-list-module__Q8vjHW__PostListContent",
});
